import axios from 'axios'

const preHttpClient = axios.create({
  baseURL: process.env.VUE_APP_CLIENT_URL_BASE,
})

// clientのversionをfetchしてくる関数
export const fetchRemoteRevision = async () => {
  try {
    const res = await preHttpClient.get('revision.json')
    return res.data.revision
  } catch (e) {
    console.log(e.message)
  }
}
